/* eslint-disable no-console */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  feed_params: {},
  feedParamsinfo: {},
  previous_feed_params: {},
  feedDict: {},
  form: {},
  feedTDS: undefined,
  feed_flow_dict: '',
};

const feedSlice = createSlice({
  name: 'feed',
  initialState,
  reducers: {
    setFeed_Params: (state, action) => {
      state.previous_feed_params = state.feed_params;
      state.feed_params = action.payload;
    },
    setFeedParamsinfo: (state, action) => {
      const data = action.payload; // Get the entire data object

      if (data && data.record && data.type && data.id) {
        const { record, type, id } = data;
        if (!state.feedParamsinfo[type]) {
          state.feedParamsinfo[type] = {};
        }
        state.feedParamsinfo[type][id] = record;
      } else {
        state.feedParamsinfo = data;
      }
      // state.feed_params = action.payload;
    },
    resetFeedParamsinfo: (state) => {
      state.feedParamsinfo = initialState.feedParamsinfo; // Reset to the initial state
    },
    resetFeed_Params: (state) => {
      state.feed_params = initialState.feed_params; // Reset to the initial state
    },
    setFeed_Dict: (state, action) => {
      const data = action.payload; // Get the entire data object

      // Guard: reject payloads with "undefined" key
      if (data && typeof data === 'object' && 'undefined' in data) {
        console.error('setFeed_Dict: rejecting payload with undefined key', data);
        return;
      }

      if (data && data.record && data.type && data.id) {
        const { record, type, id } = data;
        if (!state.feedDict[type]) {
          state.feedDict[type] = {};
        }
        state.feedDict[type][id] = record;
      } else if (data && Object.keys(data).length > 0) {
        state.feedDict = data;
      }
    },
    removeFeedDictByKey: (state, action) => {
      const itemKeyToRemove = action.payload;

      // Create a new object without the item to remove
      const updatedItems = { ...state.feedDict.feed };
      delete updatedItems[itemKeyToRemove];

      // Update the state with the new object
      state.feedDict = {feed:updatedItems};
    },
    resetFeed_Dict: (state) => {
      state.feed = initialState.feedDict; // Reset to the initial state
    },
    setFeedFormData: (state, action) => {
      const data = action.payload; // Get the entire data object

      // Guard: reject payloads with "undefined" key
      if (data && typeof data === 'object' && 'undefined' in data) {
        console.error('setFeedFormData: rejecting payload with undefined key', data);
        return;
      }

      if (data && data.record && data.type && data.id) {
        const { record, type, id } = data;
        if (!state.form[type]) {
          state.form[type] = {};
        }
        state.form[type][id] = record;
      } else if (data && Object.keys(data).length > 0) {
        state.form = data;
      }
    },
    removeFeedFormDataByKey: (state, action) => {
      const itemKeyToRemove = action.payload;

      // Create a new object without the item to remove
      const updatedItems = { ...state.form.feed };
      delete updatedItems[itemKeyToRemove];

      // Update the state with the new object
      state.form = {feed:updatedItems};
    },
    resetFeedFormData: (state) => {
      state.feed = initialState.feed; // Reset to the initial state
    },
    setFeedTDS: (state, action) => {
      state.feedTDS = action.payload;
    },
    resetFeedTDS: (state) => {
      state.feedTDS = initialState.feedTDS; // Reset to the initial state
    },
    setFeedFlowDict: (state, action) => {
      state.feed_flow_dict = action.payload;
    },
    resetFeedFlowDict: (state) => {
      state.feed_flow_dict = initialState.feed_flow_dict;
    },
    resetFeedDataSlice: () => {
      return initialState; // Return the entire initialState object
    },
  },
});

export const {
  setFeed_Params,
  resetFeed_Params,
  setFeedParamsinfo,
  resetFeedParamsinfo,
  setFeed_Dict,
  removeFeedDictByKey,
  setFeedFormData,
  resetFeedFormData,
  removeFeedFormDataByKey,
  resetFeedDataSlice,
  setFeedTDS,
  resetFeedTDS,
  setFeedFlowDict,
  resetFeedFlowDict,
} = feedSlice.actions;

// Stable default values to prevent new object creation on each selector call
const DEFAULT_EMPTY_OBJECT = {};
const DEFAULT_EMPTY_STRING = '';

// Selectors for accessing feed state from active tab
// These selectors access the feed state within the active tab's state
export const selectActiveTabFeedDict = (state) => {
  const {activeTabId} = state.tabs;
  return state.tabs.tabStates[activeTabId]?.feed?.feedDict || DEFAULT_EMPTY_OBJECT;
};

export const selectActiveTabFeedParams = (state) => {
  const {activeTabId} = state.tabs;
  return state.tabs.tabStates[activeTabId]?.feed?.feed_params || DEFAULT_EMPTY_OBJECT;
};

export const selectActiveTabFeedParamsinfo = (state) => {
  const {activeTabId} = state.tabs;
  return state.tabs.tabStates[activeTabId]?.feed?.feedParamsinfo || DEFAULT_EMPTY_OBJECT;
};

export const selectActiveTabFeedForm = (state) => {
  const {activeTabId} = state.tabs;
  return state.tabs.tabStates[activeTabId]?.feed?.form || DEFAULT_EMPTY_OBJECT;
};

export const selectActiveTabFeedTDS = (state) => {
  const {activeTabId} = state.tabs;
  return state.tabs.tabStates[activeTabId]?.feed?.feedTDS;
};

export const selectActiveTabFeedFlowDict = (state) => {
  const {activeTabId} = state.tabs;
  return state.tabs.tabStates[activeTabId]?.feed?.feed_flow_dict || DEFAULT_EMPTY_STRING;
};

// Selector factory for accessing feed state from a specific tab
export const selectTabFeedDict = (tabId) => (state) => {
  return state.tabs.tabStates[tabId]?.feed?.feedDict || DEFAULT_EMPTY_OBJECT;
};

export default feedSlice.reducer;